import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TextButtonProps {
  icon?: IconDefinition;
  onClick?: () => void;
  children?: string;
}

const TextButton: FunctionComponent<TextButtonProps> = ({
  icon,
  onClick,
  children,
}) => (
  <Flex
    sx={{
      color: '#00667D',
      flexDirection: 'row',
      alignItems: 'center',
      fontWeight: 400,
      fontSize: 'H300',
      cursor: 'pointer',
      margin: '6px auto 0 0',
    }}
    onClick={onClick}
  >
    {icon && (
      <Box sx={{ paddingRight: 'xxs', paddingLeft: 'xxs', fontWeight: 900 }}>
        <FontAwesomeIcon icon={icon} />
      </Box>
    )}
    {children}
  </Flex>
);

export default TextButton;
